import http from 'plugins/axios';

export default {
    getFeeProportion(data) {
        return http.get({
            url: '/admin/etp/feeProportion',
            data
        });
    },
    getFeeStatisticsList(data) {
        return http.get({
            url: '/admin/etp/feeStatisticsList',
            data
        });
    },
    getFeeTrend(data) {
        return http.get({
            url: '/admin/etp/feeTrend',
            data
        });
    },
    getFeeDetail(data) {
        return http.get({
            url: '/admin/etp/feeDetail',
            data
        });
    },
};
